import { useAuth } from '@/lib/auth/auth-context';

export default function UnauthorizedPage() {
  const { login } = useAuth();

  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="max-w-sm text-center">
        <div
          className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full"
          style={{ backgroundColor: 'var(--nwm-navy-50)' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-8 w-8"
            style={{ color: 'var(--nwm-navy-600)' }}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
          </svg>
        </div>
        <h1 className="mb-2 text-xl font-bold" style={{ color: 'var(--nwm-navy-900)' }}>
          Sign In Required
        </h1>
        <p className="mb-6 text-sm text-gray-500">
          Your session has expired or you are not signed in. Please sign in to continue.
        </p>
        <button
          type="button"
          className="rounded px-5 py-2 text-sm font-medium text-white transition-opacity hover:opacity-90"
          style={{ backgroundColor: 'var(--nwm-navy-700)' }}
          onClick={() => void login()}
        >
          Sign In
        </button>
      </div>
    </div>
  );
}
